import React from "react";
import moment from "moment";
import { DATE_TO_STORE, KENDO_DATE_FORMAT } from "../../../../constants";
import { Tooltip } from "@material-ui/core";
import { get } from "lodash";

const CheckinDueDate = colProps => {
  const classCss = moment(get(colProps,"dataItem.endDate",null)).format(DATE_TO_STORE) === moment().format(DATE_TO_STORE)
  ? "truncate-txt errorMessages"
  :"truncate-txt";
  return (
    <td>
      <Tooltip
        title={moment(get(colProps,"dataItem.endDate","")).format(KENDO_DATE_FORMAT)}>
        <span className={classCss}>
          {moment(get(colProps,"dataItem.endDate","")).format(KENDO_DATE_FORMAT)}
        </span>
      </Tooltip>
    </td>
  );
};

export default CheckinDueDate;
